import { ModalBody, ModalFooter, ModalHeader, ModalNext } from "@jutro/components";
import { useContext, useState } from 'react';

import PropTypes from 'prop-types';
import { useValidation } from '@xengage/gw-portals-validation-react';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { AccountService } from 'wmic-pe-capability-gateway-policy';

import { WMICButton } from 'wmic-pe-components-platform-react';
import { Loader } from '@jutro/components';
import metadata from './WMICMDENewEmailModal.metadata.json5';

import messages from './WMICMDENewEmailModal.messages';
import styles from './WMICMDENewEmailModal.module.scss';
import { TranslatorContext } from '@jutro/legacy/locale';

const WMICMDENewEmailModal = ({
    isOpen,
    onResolve,
    namedInsuredVM,
    policyNumber,
    updateMDEData,
    authHeader,
    index,
    viewModelService
}) => {
    const translator = useContext(TranslatorContext);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('WMICMDENewEmailModal');

    const [namedInsuredVMcopy, updateNamedInsuredVMcopy] = useState(viewModelService.clone(namedInsuredVM));
    const [isLoading, updateIsLoading] = useState(false);

    const handleClose = () => {
        onResolve();
    }

    const submitEmail = async () => {
        updateIsLoading(true);
        await AccountService.sendMDEInvite(
            namedInsuredVMcopy?.mdeEnrollment_Ext?.value?.email,
            true,
            policyNumber,
            namedInsuredVMcopy?.value?.mdeEnrollment_Ext?.contactId,
            authHeader
        )
            .then(isInviteSent => {
                updateMDEData(isInviteSent, index);
            })
            .finally(() => {
                updateIsLoading(false);
                handleClose();
            });
    };

    const updateEmailValue = (value, path) => {
        const newNamedInsuredVM = viewModelService.clone(namedInsuredVMcopy);
        _.set(newNamedInsuredVM, path, value);
        updateNamedInsuredVMcopy(newNamedInsuredVM);
    };

    const overrideProps = {
        '@field': {
            parentNode: namedInsuredVMcopy
        },
        accountDetailsHeader: {
            className: styles.accountDetails
        },
        insuredName: {
            content: translator(messages.noEmailHeader, { name: namedInsuredVMcopy?.displayName?.value })
        },
        loader: {
            visible: isLoading
        }
    }

    const resolvers = {
        resolveClassNameMap: styles,
    }

    return (
        <ModalNext isOpen={isOpen} className={styles.addEmailModal}>
            <ModalHeader
                title={translator(messages.sendInviteHeader)}
            />
            <ModalBody>
                {
                    isLoading ?
                        <Loader /> :
                        <ViewModelForm
                            uiProps={metadata.pageContent}
                            model={namedInsuredVMcopy}
                            overrideProps={overrideProps}
                            classNameMap={resolvers.resolveClassNameMap}
                            onValidationChange={setComponentValidation}
                            onValueChange={updateEmailValue}
                        />
                }
            </ModalBody>
            <ModalFooter>
                <WMICButton
                    onClick={handleClose}
                    type="primary-outlined">
                    {translator(messages.cancel)}
                </WMICButton>
                <WMICButton
                    onClick={submitEmail}
                    disabled={!isComponentValid || isLoading}
                    type='primary'>
                    {translator(messages.sendInviteButton)}
                </WMICButton>
            </ModalFooter>
        </ModalNext>
    )
};

WMICMDENewEmailModal.propTypes = {
    namedInsuredVM: PropTypes.shape({}).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};

export default WMICMDENewEmailModal;